import { PatientEgkCardData, SexType } from '@lmt/shared-types';

export function mockEgkCardReading(data: PatientEgkCardData) {
  const event = new CustomEvent('onEgkCardReading', {
    detail: {
      data,
    },
  });
  document.dispatchEvent(event);
}
